<script>
import { Line } from 'vue-chartjs'
import { apiGet, notify } from '../util/general'
export default {
  extends: Line,
  props  : {
    tipo : {
      type   : String,
      default: 'Garantia'
    },
    desde : {
      type   : String
    },
    hasta : {
      type   : String
    }
  },
  data () {
    return {
      listaData: [],
      chartData: {
        labels  : [],
        datasets: [
          {
            label          : `Abierto`,
            data           : [],
            fill           : false,
            borderColor    : this.$vuetify.theme.themes.light.primary,
            backgroundColor: this.$vuetify.theme.themes.light.secondary,
            borderWidth    : 1
          }
        ]
      },
      options: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            gridLines: {
              display: true
            }
          }],
          xAxes: [ {
            gridLines: {
              display: false
            },
            ticks : {
              fontSize: 11
            }
          }]
        },
        onClick:this.handle,
        legend: {
          display: false
        },
        tooltips: {
          enabled  : true,
          callbacks: {
            label: this.footer
          }
        },
        responsive         : true,
        maintainAspectRatio: false
      }
    }
  },
  created () {
    var vm = this;
    vm.fetchTicketsCerrados()
  },
  methods : {
    footer (context)  {
      var label = context.value + ' dias activo'
      return label;
    },
    handle (point, event) {
      var vm = this
      var item = event[0]
      if (item) {
        var index        = item._index
        var numero       = vm.listaData[index].numero
        var url          = vm.$router.resolve({name  : 'detalle_ticket', params : { numero : numero }})
        window.open(url.href, '_blank')
      }
    },
    render () {
      var vm = this
      vm.chartData.datasets[0].fill = !vm.$vuetify.theme.dark
      vm.renderChart(vm.chartData, vm.options)
    },
    fetchTicketsCerrados () {
      var vm = this
      vm.listaData = []
      vm.chartData.labels = []
      vm.chartData.datasets[0].data = []
      vm.isLoading = true
      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Obtener listado de tickets cerrados' })
      var obj = {
        desde     : vm.desde,
        hasta     : vm.hasta,
        tipoTicket: vm.tipo.toLowerCase()
      }

      apiGet(vm, '/ticket/obtener/cerrados/duracion', obj, function (data) {
        for (var i = 0; i < data.lista.length; i++) {
          vm.listaData.push(data.lista[i])
          vm.chartData.labels.push(data.lista[i].numero)
          vm.chartData.datasets[0].data.push(data.lista[i].diasAbierto)
        }

        vm.render()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
        vm.$store.dispatch('transaccion', { isProceso : false })
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
canvas
  max-height: 250px !important;
</style>



// WEBPACK FOOTER //
// c_chart_line_tickets_cerrados_por_horas_activo.vue?8206bc1a